import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
// import createRootReducer from './index';

import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';

//import rootReducer from './modules';
import createRootReducer from './modules';
import { LOGOUT } from './modules/auth';

import { loadLocalStorage, saveLocalStorage } from './localStorage';
import { updateAccessToken } from './modules/utility';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

//export const history = createHistory();
export const history = createBrowserHistory();

const initialState = loadLocalStorage();

const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

// noinspection JSUnresolvedVariable
if (isLocalhost) {
	//const devToolsExtension = window.devToolsExtension;
	/** @namespace window.__REDUX_DEVTOOLS_EXTENSION__ */
	const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

	if (typeof devToolsExtension === 'function') {
		enhancers.push(devToolsExtension());
	}
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const resetEnhancer = (rootReducer) => (state, action) => {
	if (action.type !== LOGOUT) {
		return rootReducer(state, action);
	}

	const newState = rootReducer(undefined, {});
	newState.router = state.router;
	return newState;
};

const store = createStore(
	resetEnhancer(createRootReducer(history)),
	//createRootReducer(history),
	initialState,
	composedEnhancers
);

store.subscribe(() => {
	saveLocalStorage(store.getState());
	updateAccessToken(store.getState());
});

export default store;
